import {
  AgeOfHousingEnum,
  HousingTypeEnum,
  MaritalStatusEnum,
  PersonalData,
  ProofOfAddressEnum,
  RejectedTypeEnum,
  RejectionStatusEnum,
  StatusClientEnum,
} from 'types';

export const defaultProspectValue = {
  id: '',
  firstName: '',
  firstLastName: '',
  secondLastName: '',
  phoneNumber: '',
  phoneLada: '',
  imageUrl: '',
  status: StatusClientEnum.CREATED,
  createdAt: new Date(),
  createdBy: '',
  personalData: {
    id: '',
    firstName: '',
    firstLastName: '',
    secondLastName: '',
    maritalStatus: MaritalStatusEnum.SINGLE,
    frontINEUrl: '',
    backINEUrl: '',
    proofOfAddressUrl: '',
    proofOfAddress: ProofOfAddressEnum.CFE,
    photoUrl: '',
  },
  contactData: {
    id: '',
    phoneNumber: '',
    phoneLada: '',
    phoneVerified: false,
    outsideAddressPhotoUrl: '',
    insideAddressPhotoUrl: '',
    latitude: 0,
    longitude: 0,
    outdoorNumber: '',
    indoorNumber: '',
    state: '',
    municipality: '',
    zipCode: '',
    street: '',
    suburb: '',
  },
  economicData: {
    id: '',
    housingType: HousingTypeEnum.OWNED,
    ageOfHousing: AgeOfHousingEnum.LESS_THAN_1_YEAR,
    economicDependants: 0,
    incomes: [],
  },
  acceptedAt: new Date(),
  rejections: [
    {
      contactData: false,
      createdAt: '',
      economicData: false,
      id: '',
      internalReason: '',
      personalData: true,
      reason: '',
      status: RejectionStatusEnum.PENDING,
      type: RejectedTypeEnum.MANUAL,
      updatedAt: '',
    },
  ],
};

export const defaultPersonalData: PersonalData = {
  id: '',
  firstName: '',
  firstLastName: '',
  secondLastName: '',
  maritalStatus: MaritalStatusEnum.SINGLE,
  frontINEUrl: '',
  backINEUrl: '',
  proofOfAddressUrl: '',
  proofOfAddress: ProofOfAddressEnum.CFE,
  photoUrl: '',
};

export const defaultContactData = {
  id: '',
  phoneNumber: '',
  phoneLada: '',
  phoneVerified: false,
  outsideAddressPhotoUrl: '',
  insideAddressPhotoUrl: '',
  latitude: 0,
  longitude: 0,
  street: '',
  municipality: '',
  suburb: '',
  zipCode: '',
  outdoorNumber: '',
  indoorNumber: '',
  state: '',
};
